"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Box = _interopRequireDefault(require("@mui/material/Box"));

var _excluded = ["name", "prefix", "className"];
var defaultProps = {
  prefix: 'ic-'
};

var CobaltIcon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var name = props.name,
      prefix = props.prefix,
      className = props.className,
      others = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], (0, _extends2["default"])({
    component: "span",
    ref: ref,
    className: (0, _clsx["default"])("".concat(prefix).concat(name), className)
  }, others));
});

CobaltIcon.defaultProps = defaultProps;
var _default = CobaltIcon;
exports["default"] = _default;